import { render, staticRenderFns } from "./DrawerAccountStatement.vue?vue&type=template&id=18482199"
import script from "./DrawerAccountStatement.vue?vue&type=script&lang=js"
export * from "./DrawerAccountStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports